/**
 * Dropzone
 *
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

require ('dropzone');

$(function() {
    "use strict";

    let config = {
        thumbnailWidth: 150,
        maxFilesize: 200,
        headers: window.axios.defaults.headers.common,
    }

    $("#dropzone").dropzone(config);
});




// WEBPACK FOOTER //
// ./resources/js/services/dropzone.js